<form (ngSubmit)="search()" [formGroup]="searchForm">
    <div style="width: 500px">
        <div class="title">Find user</div>

        <app-alert/>

        <div class="label">SupportId, RoundToken, InstallId, Email</div>
        <input autofocus class="field" formControlName="query" required type="text">

        <button [disabled]="!searchForm.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Search</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../assets/img/spinner.svg"/>
        </button>
    </div>
</form>